import queryString from "query-string";

//import { getStorage, ref, uploadBytes } from "firebase/storage";

export async function getDataByGas(
  params: { mode: string; part: string } | { mode: string }
): Promise<Response> {
  const Url =
    "https://script.google.com/macros/s/AKfycbxXZe-SY6m9n-72L7id6LqnxFf_PDjefLfv4SxxOSDAMedIj-o1-oA0S-WYqWd1jHQxCg/exec";
  //const Url = process.env.REACT_APP_DRIVE_SHOW_URL
  const controller = new AbortController();
  const timeout = setTimeout(() => {
    controller.abort();
  }, 5 * 60 * 1000); // will time out after 5minutes

  const qs = queryString.stringify(params, { arrayFormat: "bracket" });

  const response = await fetch(`${Url}?${qs}`, {
    method: "GET",
  })
    .then((response) => {
      return response;
    })
    .finally(() => {
      clearTimeout(timeout);
    });
  return response;
}

export type getDataByGasType = {
  subPart: string;
  name: string;
  path: string;
  series: number;
  start: number;
  end: number;
  studyUId: string;
};

export async function getDiseaseDataByGas(params: any) {
  const Url =
    "https://script.google.com/macros/s/AKfycbwF1R24sTEISSKRbNMB3sSASMAkiUIaBvMrg7rCMot6sqOf2JYYdMCBi0e3oMFTg0MKTQ/exec";
  //const Url = process.env.REACT_APP_DRIVE_SHOW_URL
  const controller = new AbortController();
  const timeout = setTimeout(() => {
    controller.abort();
  }, 5 * 60 * 1000); // will time out after 5minutes

  const qs = queryString.stringify(params, { arrayFormat: "bracket" });

  const response = await fetch(`${Url}?${qs}`, {
    method: "GET",
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error:", error);
    })
    .finally(() => {
      clearTimeout(timeout);
    });
  return response;
}
